<template>
  <hm-content title="">
    <div class="table-panel flex flex-start">
      <div>
        <el-button type="primary" size="small" @click="addBelt"
          >新建腰带</el-button
        >
      </div>
    </div>
    <div class=" flex flex-start">
      <div>
        <el-radio-group
          v-model="searchCondition.beltType"
          size="small"
          @change="switchTab"
        >
          <el-radio-button label="promotion">促销</el-radio-button>
          <el-radio-button label="coupon">优惠劵</el-radio-button>
          <el-radio-button label="price">到手价</el-radio-button>
        </el-radio-group>
      </div>
    </div>

    <div class="table" v-if="searchCondition.beltType === 'promotion'">
      <div class="flex flex-end text-right mb10">
        <el-input
          clearable
          v-model.trim="searchCondition.promotionName"
          placeholder="输入促销名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-select
          clearable
          v-model="searchCondition.promotionEnabledState"
          placeholder="请选择促销状态"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="上线" value="enable"></el-option>
          <el-option label="下线" value="disabled"></el-option>
        </el-select>
        <el-select
          clearable
          v-model="searchCondition.promotionCode"
          placeholder="促销类型"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            v-for="item in activityChildCategoryList"
            :key="item.promotionCode"
            :label="item.typeName"
            :value="item.promotionCode"
          ></el-option>
        </el-select>
        <el-select
          clearable
          v-model="searchCondition.enabledState"
          placeholder="请选择腰带状态"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="上线" value="yes"></el-option>
          <el-option label="下线" value="no"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="促销类形">
          <template slot-scope="scope">
            <div class="table-status flex item-center">
              <span
                class="status success-bg"
                v-show="scope.row.timeStatus == 'running'"
              ></span>
              <span
                class="status gray-bg"
                v-show="scope.row.timeStatus == 'notStarted'"
              ></span>
              <span
                class="status danger-bg"
                v-show="scope.row.timeStatus == 'end'"
              ></span>
              <span class="flex flex-1 flex-start">{{
                scope.row.typeName
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="promotionName"
          label="促销名称"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              :content="scope.row.promotionName"
              placement="top"
            >
              <div class="flex item-center">
                <span class="pos" v-if="scope.row.createMode">
                  p
                </span>
                <span class="time flex-1 text-overflow">
                  {{ scope.row.promotionName }}
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="startDateFormat"
          label="促销时段"
          width="200px"
        >
          <template slot-scope="scope">
            <span class="time">
              {{ scope.row.startDate }}至{{ scope.row.endDate }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="促销状态"
        >
          <template slot-scope="scope">
            <span
              class="status danger"
              v-show="scope.row.promotionEnabledState === 'disabled'"
              >下线</span
            >
            <span
              class="status success"
              v-show="scope.row.promotionEnabledState === 'enable'"
              >上线</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="beltPriorityLevel"
          label="腰带优先级"
        >
          <template slot-scope="scope">
            {{ scope.row.beltPriorityLevel }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="腰带创建时间"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="forecastTime"
          label="预告时间"
        >
          <template slot-scope="scope">
            {{ scope.row.forecastTime }}
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="腰带状态"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.timeStatus === 'end'">
              已结束
            </div>
            <div v-else>
              <span class="success" v-if="scope.row.enabledState === 'yes'">
                上线
              </span>
              <span class="danger" v-if="scope.row.enabledState === 'no'">
                下线
              </span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="deliverSn"
          label="腰带缩略图"
        >
        </el-table-column> -->
        <el-table-column label="操作" header-align="center" align="center" width="200">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <!-- <div v-if="scope.row.timeStatus === 'end'">
                --
              </div> -->

              <el-button
                size="small"
                class="danger"
                type="text"
                v-if="
                  scope.row.enabledState === 'yes' &&
                    scope.row.timeStatus !== 'end'
                "
                @click="edit(scope.row)"
                >下线</el-button
              >
              <el-button
                size="small"
                class="success"
                type="text"
                v-if="
                  scope.row.enabledState === 'no' &&
                    scope.row.timeStatus !== 'end'
                "
                @click="edit(scope.row)"
                >上线</el-button
              >

              <el-button
                size="small"
                class="danger"
                type="text"
                @click="remove(scope.row)"
                >删除</el-button
              >
            </div>
            <div class="flex flex-center">
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="toDetails(scope.row)"
                >促销详情</el-button
              >
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="detailBelt(scope.row)"
                >查看腰带模板样式</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <hm-status />
    </div>
    <div class="table" v-if="searchCondition.beltType === 'coupon'">
      <div class="flex flex-end text-right mb10">
        <el-input
          clearable
          v-model.trim="searchCondition.name"
          placeholder="請输入优惠劵名称"
          size="small"
          style="width:220px;"
          class="mr10"
        ></el-input>
        <el-select
          clearable
          v-model="searchCondition.enabledState"
          placeholder="请选择腰带状态"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="上线" value="yes"></el-option>
          <el-option label="下线" value="no"></el-option>
        </el-select>

        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="优惠券名"
        >
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="levelMin"
          label="使用门槛"
        >
          <template slot-scope="scope">
            {{ scope.row.levelMin }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="account"
          label="减免金额"
        >
          <template slot-scope="scope">
            {{ scope.row.account }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="有效期"
          width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.useInTime }}
            <div v-if="scope.row.useImmediately !== 1">
              <!-- <el-button
                size="small"
                type="text"
                @click="getRuleTime(scope.row.ruleId)"
                v-if="
                  !scope.row.useInTime &&
                    scope.row.validTime &&
                    scope.row.ruleTimeStrategyType !== 4
                "
                >{{ scope.row.validTime }}</el-button
              > -->
              <span v-if="scope.row.useInTime">{{ scope.row.useInTime }}</span>
              <span
                v-else-if="scope.row.ruleTimeStrategyType === 4"
                style="font-size: 12px;"
              >
                {{
                  `${scope.row.ruleStartDate} ${
                    scope.row.ruleStartTime.split(",")[0]
                  }`
                }}
                <br />
                至{{
                  `${scope.row.ruleEndDate} ${
                    scope.row.ruleEndTime.split(",")[0]
                  }`
                }}
              </span>
            </div>
            <span v-if="scope.row.useImmediately === 1">
              {{ scope.row.immediatelyEffective }}小时后生效，有效期{{
                scope.row.immediatelyEffectiveDays
              }}小时
            </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="beltPriorityLevel"
          label="腰带优先级"
        >
          <template slot-scope="scope">
            {{ scope.row.beltPriorityLevel }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="腰带创建时间"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="forecastTime"
          label="预告时间"
        >
          <template slot-scope="scope">
            {{ scope.row.forecastTime }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="deliverSn"
          label="腰带状态"
        >
          <template slot-scope="scope">
            <span class="success" v-if="scope.row.enabledState === 'yes'">
              上线
            </span>
            <span class="danger" v-if="scope.row.enabledState === 'no'">
              下线
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="deliverSn"
          label="腰带缩略图"
        >
        </el-table-column> -->
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                class="danger"
                type="text"
                v-if="scope.row.enabledState === 'yes'"
                @click="edit(scope.row)"
                >下线</el-button
              >
              <el-button
                size="small"
                class="success"
                type="text"
                v-else
                @click="edit(scope.row)"
                >上线</el-button
              >
              <el-button
                size="small"
                class="danger"
                type="text"
                @click="remove(scope.row)"
                >删除</el-button
              >
            </div>
            <div class="flex flex-center">
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="
                  copy(
                    scope.row.selectId,
                    scope.row.type,
                    scope.row.couponStatus,
                    scope.row.useRank
                  )
                "
                >优惠劵详情</el-button
              >
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="detailBelt(scope.row)"
                >查看腰带模板样式</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="table" v-if="searchCondition.beltType === 'price'">
      <div class="flex flex-end text-right mb10">
        <el-input
          clearable
          v-model.trim="searchCondition.spuName"
          placeholder="請输入商品名称"
          size="small"
          style="width:220px;"
          class="mr10"
        ></el-input>

        <el-select
          clearable
          v-model="searchCondition.enabledState"
          placeholder="请选择腰带状态"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="上线" value="yes"></el-option>
          <el-option label="下线" value="no"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="spuName"
          label="商品名称"
        >
          <template slot-scope="scope">
            {{ scope.row.spuName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="selectId"
          label="商品货号"
        >
          <template slot-scope="scope">
            {{ scope.row.selectId }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="handPrice"
          label="到手价"
        >
          <template slot-scope="scope">
            {{ scope.row.handPrice }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="activityStartTime"
          label="活动时段"
        >
          <template slot-scope="scope">
            {{ scope.row.activityStartTime }}至{{ scope.row.activityEndTime }}
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="腰带创建时间"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="forecastTime"
          label="预告时间"
        >
          <template slot-scope="scope">
            {{ scope.row.forecastTime }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="deliverSn"
          label="腰带状态"
        >
          <template slot-scope="scope">
            <span class="success" v-if="scope.row.enabledState === 'yes'">
              上线
            </span>
            <span class="danger" v-if="scope.row.enabledState === 'no'">
              下线
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                class="danger"
                type="text"
                v-if="scope.row.enabledState === 'yes'"
                @click="edit(scope.row)"
                >下线</el-button
              >
              <el-button
                size="small"
                class="success"
                type="text"
                v-else
                @click="edit(scope.row)"
                >上线</el-button
              >
              <el-button
                size="small"
                class="danger"
                type="text"
                @click="remove(scope.row)"
                >删除</el-button
              >
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="detailBelt(scope.row)"
                >查看腰带模板样式</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <!-- <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      title="腰带类型"
    >
      <span
        class="mr20"
        style="font-weight:600;color:rgba(34,34,34,1);lineheight:48px;"
        >选择腰带类型</span
      >
      <el-radio-group v-model="beltType" size="small">
        <el-radio label="promotion">促销</el-radio>
        <el-radio label="price">到手价</el-radio>
        <el-radio label="coupon">优惠券</el-radio>
      </el-radio-group>

      <span slot="footer" class="flex flex-center">
        <el-button type="primary" size="small" @click="gogogo">确 定</el-button>
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog> -->
    <el-dialog :visible.sync="dialogVisibleBelt" title="查看腰带模板样式">
      <div class="mt10 flex flex-center">
        <div class="preview">
          <belt
            :backgroundImage="backgroundImage"
            :index="activeItem"
            :textList="textList"
          >
            <div slot="swiper" class="swiper"></div>
          </belt>
        </div>
      </div>
      <span slot="footer" class="flex flex-center">
        <el-button size="small" @click="dialogVisibleBelt = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmStatus from "@/components/HmStatus";
import { compact } from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";
import belt from "@/components/belt";
export default {
  components: {
    HmStatus,
    belt
  },
  data() {
    return {
      backgroundImage: "",
      beltTypeBg: "",
      activeItem: 1,
      ruleForm: {},
      activityChildCategoryList: [],
      searchCondition: {
        beltType: "promotion"
      },
      beltType: "promotion",
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogVisibleBelt: false,
      textList: []
    };
  },
  computed: mapGetters(["activityCategoryList"]),
  watch: {
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    }
  },
  created() {},
  mounted() {
    this.queryList();
    this.$store.dispatch("queryActivityCategoryList");
  },
  methods: {
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("queryBeltList", params);
      const { records, total } = result;
      this.list = records;
      this.total = total;
      if (this.searchCondition.beltType === "coupon") {
        this.list.forEach(item => {
          let records = [];
          item.labelMap &&
            item.labelMap.forEach(v => {
              records.push(v.labelName);
            });
          item.labelName = records.toString();
          if (item.useInTime >= 24) {
            item.useInTime = Number.isInteger(item.useInTime / 24)
              ? item.useInTime / 24 + "天"
              : Math.floor(item.useInTime / 24) +
                "天" +
                (item.useInTime % 24) +
                "小时";
          } else {
            item.useInTime = item.useInTime ? item.useInTime + "小时" : "";
          }
          item.validTime =
            item.ruleStartDate &&
            item.ruleEndDate &&
            item.ruleStartDate + "至" + item.ruleEndDate;
          switch (item.status) {
            case 0:
              item.statusFormat = "未开始";
              break;
            case 1:
              item.statusFormat = "进行中";
              break;
            case 2:
              item.statusFormat = "已作废";
              break;
            default:
              break;
          }
          switch (item.useRank) {
            case 0:
              item.useRankFormat = "通用";
              break;
            case 1:
              item.useRankFormat = "微店";
              break;
            case 2:
              item.useRankFormat = "门店";
              break;
            default:
              break;
          }
          switch (item.platform) {
            case 0:
              item.platformFormat = "禾苗主系统";
              break;
            case 1:
              item.platformFormat = "服务";
              break;
            case 2:
              item.platformFormat = "嘉年华";
              break;
            default:
              item.platformFormat = "禾苗主系统";
              break;
          }
          //
          if (item.ruleEndTime && item.ruleStartTime) {
            // 获取时间列表
            const endTimeList = compact(item.ruleEndTime.split(",")).sort();
            const startTimeList = compact(item.ruleStartTime.split(",")).sort();
            // 获取最大结束时间 和最小开始时间
            const startTimeListMax = startTimeList[0];
            const endTimeListMax = endTimeList[endTimeList.length - 1];
            const startDate =
              item.ruleStartDate +
              (startTimeListMax ? " " + startTimeListMax : "");
            const endDate =
              item.ruleEndDate + (endTimeListMax ? " " + endTimeListMax : "");
            if (moment().isBefore(moment(startDate, moment.ISO_8601))) {
              item.statusFormat = "未开始";
            } else if (
              moment().isAfter(moment(endDate, moment.ISO_8601)) &&
              item.status !== 2
            ) {
              item.statusFormat = "已过期";
            }
          }
          switch (item.statusFormat) {
            case "未开始":
              item.couponStatus = 0;
              break;
            case "进行中":
              item.couponStatus = 1;
              break;
            default:
              item.couponStatus = "null";
              break;
          }
          item.isPlusFormat =
            item.isPlus === 0
              ? "PLUS会员"
              : item.isPlus === 1
                ? "全部会员"
                : "全部会员";
        });
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    // addBelt() {
    //   this.dialogVisible = true;
    // },
    edit(row) {
      let params = {
        enabledState: row.enabledState === "yes" ? "no" : "yes",
        beltConfigId: row.beltConfigId
      };
      this.$store.dispatch("editBelt", params).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.queryList();
        }
      });
    },
    remove(row) {
      this.$confirm(`确实删除该条腰带?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("delBelt", {
            beltConfigId: row.beltConfigId
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    },
    addBelt() {
      this.$router.push({
        name: "AddPromotionalBelt",
        query: {
          beltType: this.beltType
        }
      });
    },
    detailBelt(row) {
      this.dialogVisibleBelt = true;
      this.backgroundImage = row.backgroundImg;
      this.beltTypeBg = row.beltType;
      this.activeItem = +row.templateType.replace("model", "");
      this.textList = JSON.parse(row.previewComponents);
      this.ruleForm = row;
      // if (this.beltTypeBg === "promotion") {
      //   this.ruleForm.applyDate = [
      //     `${this.ruleForm.startDate} 00:00:00`,
      //     `${this.ruleForm.endDate} 23:59:59`
      //   ];
      // } else if (this.beltTypeBg === "price") {
      //   this.ruleForm.applyDate = [
      //     this.ruleForm.activityStartTime,
      //     this.ruleForm.activityEndTime
      //   ];
      // } else if (this.beltTypeBg === "coupon") {
      //   this.ruleForm.applyDate = [
      //     `${this.ruleForm.ruleStartDate} ${
      //       this.ruleForm.ruleStartTime.split(",")[0]
      //     }`,

      //     `${this.ruleForm.ruleEndDate} ${
      //       this.ruleForm.ruleEndTime.split(",")[0]
      //     }`
      //   ];
      // }
    },
    toDetails(row) {
      this.$router.push({
        name: "ActivityDetails",
        query: {
          id: row.selectId,
          type: row.auditState,
          parentId: row.promotionCode.split("-")[0],
          mode: "view"
        }
      });
    },
    copy(ruleId, index, couponStatus, couponType) {
      // this.setConditions(this.currentPage);
      this.$router.push({
        name: "Set",
        query: { type: "detail", ruleId, couponStatus, couponType }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: -2px;
}

.preview {
  width: 375px;
  box-shadow: 0px 3px 32px 0px rgba(221, 221, 221, 0.58);
  margin-bottom: 20px;
  position: relative;
  .active-img {
    width: 60px;
    height: 60px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 99999;
  }
  &.active {
    opacity: 0.9;
    color: #e50065;
  }
  .swiper {
    width: 375px;
    height: 375px;
    background: #ffeaf3;
  }
  .belt-temp {
    height: 88px;
  }
  .belt-name {
    padding: 10px;
    text-align: center;
    font-size: 18px;
  }
}
</style>
